export default __webpack_public_path__ + "static/media/tik-tok.94073078.png";